import Pregnancy from "../../../entities/Pregnancy/ui/Pregnancy";

const PregnancyPage = () => {
    return ( 
        <main>
            <Pregnancy/>
        </main>
     );
}
 
export default PregnancyPage;